import { CmsCollectionWrapper } from "../cms-collection-wrapper/cms-collection-wrapper.entity";
import { CmsResponseWrapper } from "../cms-response-wrapper/cms-response-wrapper.entity";
import { CmsTag } from "../cms-tag/cms-tag.entity";

export class CmsTagApiResponse extends CmsResponseWrapper<CmsCollectionWrapper<CmsTag>[]> {}
